// requestUrls.js

const requestUrls = {
    loginRedirect: {
      localhost: 'https://www.localhost.com/auth/login?returnUrl=https://www.localhost.com/us/en/home.html',
      dev: 'https://www.dev.thermofisher.com/auth/login?returnUrl=https://www.dev.thermofisher.com/us/en/home.html',
      dev2: 'https://www.dev2.thermofisher.com/auth/login?returnUrl=https://www.dev2.thermofisher.com/us/en/home.html',
      dev3: 'https://www.dev3.thermofisher.com/auth/login?returnUrl=https://www.dev3.thermofisher.com/us/en/home.html',
      qa: 'https://www.qa.thermofisher.com/auth/login?returnUrl=https://www.qa.thermofisher.com/us/en/home.html',
      qa1: 'https://qa1.thermofisher.in/auth/login?returnUrl=https://www.qa.thermofisher.com/us/en/home.html',
      'qa-identity': 'https://www.qa.thermofisher.com/auth/login?returnUrl=https://www.qa.thermofisher.com/us/en/home.html',
      qa2: 'https://www.qa2.thermofisher.com/auth/login?returnUrl=https://www.qa2.thermofisher.com/us/en/home.html',
      qa3: 'https://www.qa3.thermofisher.com/auth/login?returnUrl=https://www.qa3.thermofisher.com/us/en/home.html',
      qa4: 'https://www.qa4.thermofisher.com/auth/login?returnUrl=https://www.qa4.thermofisher.com/us/en/home.html',
      'dev-identity': 'https://www.qa4.thermofisher.com/auth/login?returnUrl=https://www.qa4.thermofisher.com/us/en/home.html',
      qa5: 'https://www.qa5.thermofisher.com/auth/login?returnUrl=https://www.qa5.thermofisher.com/us/en/home.html',
      stage: 'https://www.stage.thermofisher.com/auth/login?returnUrl=https://www.stage.thermofisher.com/us/en/home.html',
      thermofisher: 'https://www.thermofisher.com/auth/login?returnUrl=https://www.thermofisher.com/us/en/home.html',
      'identity': 'https://www.thermofisher.com/auth/login?returnUrl=https://www.thermofisher.com/us/en/home.html'
    },
    cloudRedirect:{
        localhost: 'http://localhost.apps.thermofisher.com/apps/dashboard/#/',
        dev:'http://dev.apps.thermofisher.com/apps/dashboard/#/',
        dev2: 'http://dev2.apps.thermofisher.com/apps/dashboard/#/',
        dev3: 'http://dev2.apps.thermofisher.comapps/dashboard/#/',
        qa: 'https://test.apps.thermofisher.com/apps/dashboard/#/',
        'qa-identity': 'https://test.apps.thermofisher.com/apps/dashboard/#/',
        qa1: 'https://test.apps.thermofisher.com/apps/dashboard/#/',
        qa2: 'https://test.apps.thermofisher.com/apps/dashboard/#/',
        qa3: 'https://test.apps.thermofisher.com/apps/dashboard/#/',
        qa4: 'https://dev2.apps.thermofisher.com/apps/dashboard/#/',
        'dev-identity': 'https://dev2.apps.thermofisher.com/apps/dashboard/#/',
        qa5: 'https://test.apps.thermofisher.com/apps/dashboard/#/',
        stage: 'https://test.apps.thermofisher.com/apps/dashboard/#/',
        thermofisher: 'https://apps.thermofisher.com/apps/dashboard/#/',
        identity: 'https://apps.thermofisher.com/apps/dashboard/#/'
    },
    chinaCloudRedirect:{
        localhost: 'http://localhost.china.apps.thermofisher.com/apps/dashboard/#/',
        dev:'http://dev.apps.thermofisher.com/apps/dashboard/#/',
        dev2: 'http://dev2.apps.thermofisher.com/apps/dashboard/#/',
        dev3: 'http://dev2.apps.thermofisher.com/apps/dashboard/#/',
        qa: 'https://stage.china.apps.thermofisher.com/apps/dashboard/#/',
        qa1: 'https://stage.china.apps.thermofisher.com/apps/dashboard/#/',
        qa2: 'https://stage.china.apps.thermofisher.com/apps/dashboard/#/',
        qa3: 'https://stage.china.apps.thermofisher.com/apps/dashboard/#/',
        qa4: 'https://stage.china.apps.thermofisher.com/apps/dashboard/#/',
        qa5: 'https://stage.china.apps.thermofisher.com/apps/dashboard/#/',
        stage: 'https://stage.china.apps.thermofisher.com/apps/dashboard/#/',
        thermofisher: 'https://china.apps.thermofisher.com/apps/dashboard/#/'
    },
  };
  
  export default requestUrls;
  